import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import classes from "./SeriesDetail.module.scss";
import Input from "../../../../../components/Common/Input/Input";
import Button from "../../../../../components/Common/Button/Button";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import InfoIcon from "../../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import { seriesManagement } from "../../../../../utils/mainTabs/organize/seriesManagement";
import {
  isNameExistActionHandler,
  getSearchProgramTagsActionHandler,
} from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import { addSeriesMgmt } from "../../../../../utils/mainTabs/organize/addSeriesMgmt";
import SelectThumbnail from "../../../../../containers/manage/CreateShotClass/SelectThumbnail/SelectThumbnail";
import { setSeriesShotclassDataAction } from "../../../../../store/actions/actionCreators/organizeActionCreator";
import { getCertificateActionHandler } from "../../../../../store/actions/actionHandlers/distributeActionHandler";
import ViewIcon from "../../../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import ViewCertificateModal from "../../../../DistributePage/CreateSeries/CertificateSettings/ViewCertificate/ViewCertificateModal/ViewCertificateModal";
import { dateFormatyyyymmdd } from "../../../../SocialPage/PollManagement/DistributePoll/DistributePollForm/DistributePollForm";
import moment from "moment";
import SelectThumbnailPopUp from "../../../../../components/Common/SelectThumbnailPopUp/SelectThumbnailPopUp";
import { FormattedMessage, injectIntl } from "react-intl";
import Loader from "../../../../../components/Common/Loader/Loader";
import RoleMenuChek from "../../../../../hoc/RoleMenuCheck";
import { featureList } from "../../../../../utils/featureList";
import Modal from "../../../../../components/Common/Modal/Modal";
import ViewContent from "../../../../../containers/manage/CreateShotClass/ViewContent/ViewContent";
import { setCertificateByProgramIdAction } from "../../../../../store/actions/actionCreators/distributeActionCreator";
yup.addMethod(yup.number, "notifyChange", function (message, DueDate) {
  return this.test(
    "notifyChange",
    message,
    function (NoDaysToNotifyBeforeDueDate) {
      const fromDate = moment(new Date(DueDate));
      const currentDate = moment(new Date());
      const diff = fromDate.diff(currentDate, "days");
      return diff > NoDaysToNotifyBeforeDueDate;
    }
  );
});
export const seriesMgmtchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Name is required")
    .max(80, "Name is required."),
  // TagsList: yup
  //   .array(
  //     yup.object().shape({
  //       TagName: yup.string(),
  //       TagValue: yup.string(),
  //     })
  //   )
  //   .min(1, "Tag is required."),
  // description: yup.string().required("Description is required"),
  TagsList: yup
    .array(
      yup.object().shape({
        TagName: yup.string(),
        TagValue: yup.string(),
      })
    )
    .notRequired(),
  // description: yup.string().notRequired(),
  // ThumbnailImage: yup.mixed().required("Thumbnail Image is required."),
  ThumbnailImage: yup
    .mixed()
    .required()
    .test("ThumbnailImage", "Thumbnail Image is required!", (value) => {
      if (value?.length < 1) return false;
      return true;
    }),
  NoDaysToNotifyBeforeDueDate: yup.number().typeError("This Field is required"),
  // NoDaysToNotifyBeforeDueDate: yup
  //   .number()
  //   .typeError("must be a number")
  //   .test(
  //     "",
  //     "Please change the Due Date or Number of days so that User can receive notification.",
  //     function (NoDaysToNotifyBeforeDueDate, ctx) {
  //       const DueDate = this.parent.DueDate;
  //       console.log(NoDaysToNotifyBeforeDueDate, DueDate);
  //       const fromDate = moment(new Date(DueDate));
  //       const currentDate = moment(new Date());
  //       const diff = fromDate.diff(currentDate, "days");
  //       console.log(
  //         diff,
  //         NoDaysToNotifyBeforeDueDate,
  //         NoDaysToNotifyBeforeDueDate <= diff + 1
  //       );
  //       if (NoDaysToNotifyBeforeDueDate <= diff + 1 && DueDate) return true;
  //       else if (NoDaysToNotifyBeforeDueDate > diff + 1 && DueDate)
  //         return ctx.createError({
  //           message:
  //             "Please change the Due Date or Number of days so that User can receive notification.",
  //         });
  //       else
  //         return ctx.createError({
  //           message: "",
  //         });
  //     }
  //   ),
  // yup.number().when("DueDate", {
  // is: (DueDate, NoDaysToNotifyBeforeDueDate) => {
  //   console.log(DueDate, );
  //   //  yup.number().notifyChange("test", DueDate);
  // },
  // then: yup.number(),
  // then: (DueDate, test) => {
  //   // debugger;
  //   console.log(DueDate, test);
  //   return yup.number().notifyChange("test", DueDate);
  // },
  // (DueDate, NoDaysToNotifyBeforeDueDate) => {
  // console.log(DueDate, NoDaysToNotifyBeforeDueDate);
  // return (
  //   new Date(DueDate).getDate() - new Date().getDate() >
  //   NoDaysToNotifyBeforeDueDate
  // );

  // },
  // then: yup.string().required("test"),
  // otherwise: yup.number().required("This field is required."),
  // }),
  DueDate: yup.string().when("CanDisplayClassPostDuedate", {
    is: true,
    then: yup.string().nullable(),
    otherwise: yup.string().required("Due-date is required.").nullable(),
  }),
  IsSelfPacedProgram: yup.boolean(),
  IsSpreadProgram: yup.boolean(),
  CanDisplayClassPostDuedate: yup.boolean(),
  Title: yup.string(),
  Certificate: yup.string(),
});

const SeriesDetail = ({ intl }) => {
  const date = moment().add(1, "days");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routerParam = useParams();
  const thumnailFileRef = useRef(null);
  const [searchTagsList, setSearchTagsList] = useState([]);
  const [exitTopicExist, setExitTopicExist] = useState(null);
  // const [loader, setLoader] = useState(true);
  const {
    formData,
    setFormData,
    pathType,
    classTypeData,
    tenantName,
    seriesEditPath,
    seriesCopyPath,
    setLoader,
    loader,
  } = useOutletContext();
  // const organizeState = useSelector((state) => state.organizeReducer);
  // const { seriesShotclassDataAction } = organizeState;
  const [certificateData, setCertificateData] = useState([]);
  const [certificateLoader, setCertificateLoader] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const commonState = useSelector((state) => state.commonReducer);
  const [notifyChangeErrorMsg, setnotifyChangeErrorMsg] = useState("");
  const [isSselectThumbnailModal, setIsSselectThumbnailModal] = useState(false);
  const [thumbnailFileName, setThumbnailFileName] = useState("");
  const [validClassName, setValidClassName] = useState(true);
  const [validTagSearch, setValidTagSearch] = useState(true);
  const [tagListValid, setTagListValid] = useState(true);
  const distributeState = useSelector((state) => state.distributeReducer);
  const { certificateByProgramId } = distributeState;
  const [selectedCertificate, setSelectedCertificate] = useState([]);
  // console.log(certificateByProgramId);
  const { colors } = commonState;
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(seriesMgmtchema),
    defaultValues: useMemo(() => {
      return {
        ...formData.details,
        Certificate: formData.details.Certificate || "",
        CertificateUrl: formData.details.CertificateUrl || "",
      };
    }, [formData.details]),
  });
  // console.log(formData);
  const disableFields = location.pathname.includes(addSeriesMgmt.editpath);
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    watch,
    setValue,
    getValues,
    trigger,
  } = methods;
  let thumbnailName = watch("ThumbnailImage");
  const canDisplayClassPostDuedate = watch("CanDisplayClassPostDuedate");
  const certificate = watch("Certificate");
  const title = watch("Title");
  const name = watch("name");
  const noDaysToNotifyBeforeDueDate = watch("NoDaysToNotifyBeforeDueDate");
  const certificateVal = watch("Certificate");
  // console.log(certificateVal)
  const clearAll = () => {
    reset();
  };
  useEffect(() => {
    reset(() => formData.details);
    dispatch(
      getCertificateActionHandler(setCertificateLoader, setCertificateData)
    );
    // if (certificateByProgramId) {
    //   setSelectedCertificate(certificateByProgramId);
    // }
  }, [formData.details, reset, dispatch, pathType]);
  const handleCancelImage = useCallback(() => {
    trigger(["ThumbnailImage"]);
  }, [trigger]);
  useEffect(() => {
    reset(() => formData?.details);
  }, [formData?.details]);
  // useEffect(() => {
  //   if (formData?.details?.description.length == 0) {
  //     setLoader(false);
  //   }
  //   else if(formData?.details?.description.length > 0){
  //     setLoader(false)
  //   }
  // }, [setLoader]);

  useEffect(() => {
    if (isViewModal) setValue("Title", name);
  }, [isViewModal, name, setValue]);

  const handleNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
          setValidClassName(true);
          dispatch(isNameExistActionHandler(val, "program", setExitTopicExist));
        } else {
          setValidClassName(false);
        }
        // dispatch(isNameExistActionHandler(val, "program", setExitTopicExist));
      } else {
        setValidClassName(true);
        setExitTopicExist(false);
      }
    },
    [dispatch, setExitTopicExist, setValidClassName]
  );

  const tagValid = watch(["TagsList"]);
  const handleSearchTags = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[A-Za-z0-9@# ]+$/.test(val)) {
          setValidTagSearch(true);
          setTagListValid(true);
          dispatch(
            getSearchProgramTagsActionHandler(e.target.value, setSearchTagsList)
          );
        } else {
          setValidTagSearch(false);
          setTagListValid(false);
        }
      } else {
        setValidTagSearch(true);
        setTagListValid(true);
        setSearchTagsList([]);
      }
    },
    [dispatch, setValidTagSearch, setTagListValid]
  );
  // console.log("formData in series details", formData);
  const onSubmit = (data) => {
    setFormData((formData) => {
      return {
        ...formData,
        details: {
          Certificate: certificateVal,
          ...formData.details,
          ...data,
        },
      };
    });
    if (pathType === "edit") {
      navigate(
        `${addSeriesMgmt.editpath(tenantName)}/${
          routerParam?.seriesID
        }/seriesContent`
      );
    } else if (pathType === "copy") {
      navigate(
        `${addSeriesMgmt.copypath(tenantName)}/${
          routerParam?.seriesID
        }/seriesContent`
      );
    } else {
      const updatedData = classTypeData?.map((item) => {
        if (item?.isChecked) {
          return { ...item, isChecked: false, disabled: false };
        } else {
          return item;
        }
      });
      dispatch(setSeriesShotclassDataAction(updatedData));
      navigate(
        `${addSeriesMgmt.path(location, routerParam, tenantName)}/seriesContent`
      );
    }
  };

  const [activeSection, setActiveSection] = useState(0);
  useEffect(() => {}, [activeSection]);

  const handleClickFileButton = () => {
    setIsSselectThumbnailModal(true);
  };

  const okBtnClick = () => {
    setActiveSection(3);
    setIsSselectThumbnailModal(false);
  };

  const checkDateDiff = (DueDate, val) => {
    const fromDate = moment(new Date(DueDate));
    const currentDate = moment(new Date());
    const diff = fromDate.diff(currentDate, "days");
    const pastDateFlag = fromDate.diff(currentDate) <= 0;
    if (!pastDateFlag) return val <= diff + 1;
    else return false;
  };

  const notifyChange = (e) => {
    const val = e?.target?.value?.trim();
    if (val) {
      const DueDate = getValues("DueDate");
      const flag = checkDateDiff(DueDate, val);
      if (flag && DueDate) setnotifyChangeErrorMsg("");
      else
        setnotifyChangeErrorMsg(
          "Please change the Due Date or Number of days so that User can receive notification."
        );
    } else setnotifyChangeErrorMsg("");
  };

  const dueDateChange = (e) => {
    const val = e?.target.value;
    if (val) {
      const NoDaysToNotifyBeforeDueDate = getValues(
        "NoDaysToNotifyBeforeDueDate"
      );
      const flag = checkDateDiff(val, NoDaysToNotifyBeforeDueDate);
      if (flag) setnotifyChangeErrorMsg("");
      else
        setnotifyChangeErrorMsg(
          "Please change the Due Date or Number of days so that User can receive notification."
        );
    } else setnotifyChangeErrorMsg("");
  };

  useEffect(() => {
    if (pathType === "edit" || pathType === "copy") {
      const NoDaysToNotifyBeforeDueDate = getValues(
        "NoDaysToNotifyBeforeDueDate"
      );
      const DueDate = getValues("DueDate");
      const flag = checkDateDiff(DueDate, NoDaysToNotifyBeforeDueDate);
      if (flag) setnotifyChangeErrorMsg("");
      else
        setnotifyChangeErrorMsg(
          "Please change the Due Date or Number of days so that User can receive notification."
        );
    }
  }, [pathType, getValues]);

  // useEffect(() => {
  //   console.log(formData);
  // }, [formData]);
  return loader ? (
    <Loader page />
  ) : (
    <div className={classes.seriesDetailsMain}>
      <FormProvider {...methods}>
        <h1 className={classes.title}>Add Series Details</h1>
        <form onSubmit={handleSubmit(onSubmit)}>
          {activeSection === 3 ? (
            <SelectThumbnail setActiveSection={setActiveSection} />
          ) : (
            <div className={classes.seriesFormsMain}>
              <div>
                <div className={classes.seriesForms}>
                  <div className={classes.nameValidation}>
                    <Input
                      label={<FormattedMessage id="P_Name" />}
                      name="name"
                      placeholder={"Enter Series Name"}
                      labelColor="dark"
                      required
                      onChange={handleNameExists}
                      error={errors?.name?.message}
                      disabled={disableFields || pathType === "edit"}
                      maxLength={80}
                      autoComplete="off"
                    />
                    {errors?.Name?.message ? (
                      <div className={classes.seriesAlreadyExist}>
                        {errors.name?.message}
                      </div>
                    ) : exitTopicExist ? (
                      <div className={classes.seriesAlreadyExist}>
                        Sorry, name already exists
                      </div>
                    ) : !validClassName ? (
                      <div className={classes.seriesAlreadyExist}>
                        Only alphanumeric and special characters like ':#@?[]_`|
                        are allowed
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div>
                    <Input
                      label={"Search Tag"}
                      name="TagsList"
                      fieldName="TagName"
                      fieldValue="TagValue"
                      placeholder={"Enter Tag Here & Tap Plus Icon"}
                      labelColor="dark"
                      // required
                      type="tags"
                      searchTagsList={searchTagsList}
                      isValidTagSearch={validTagSearch}
                      onChange={(e) => handleSearchTags(e)}
                      // error={errors?.TagsList?.message}
                      // disabled={formData?.details?.Status}
                      isDirty
                    />
                    {!validTagSearch ? (
                      <div className={classes.seriesAlreadyExist}>
                        Only alphanumeric and special characters like @# are
                        allowed
                      </div>
                    ) : !tagListValid ? (
                      <div className={classes.seriesAlreadyExist}>
                        Tag is required
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  <Input
                    label={<FormattedMessage id="DESCRIPTION_TEXT" />}
                    name="description"
                    placeholder={"Enter Series Description..."}
                    labelColor="dark"
                    type="textarea"
                    // error={errors?.description?.message}
                    // required={true}
                    autoComplete="off"
                    maxLength={200}
                  />
                  <div className={classes.uploadThumbnailBtn}>
                    <Input
                      label={<FormattedMessage id="UPLOADIMAGE_TEXT" />}
                      name="ThumbnailImage"
                      labelColor="dark"
                      hidden={true}
                      type="file"
                      required={true}
                      // error={errors?.ThumbnailImage?.message}
                      accept=".png, .jpg, .gif, .bmp"
                      width="21"
                      disableLabelClick={true}
                      fileInputView={pathType === "edit" || pathType === "copy"}
                      handleFileInputView={false}
                      handleClickFileButton={handleClickFileButton}
                      fileInputName={
                        "ThumbnailImage" ? thumbnailName?.FileName : ""
                      }
                      // disabled={formData?.details?.Status}
                      handleCancelFileInput={() => handleCancelImage()}
                    />
                    <div className={classes.infoIcon}>
                      <Tooltip
                        direction="bottom"
                        content="Format Supported: .png, .jpg, .gif, .bmp"
                      >
                        <InfoIcon />
                      </Tooltip>
                    </div>
                  </div>
                  {!canDisplayClassPostDuedate ? (
                    <div className={classes.notify}>
                      <Input
                        label={`Notify ${noDaysToNotifyBeforeDueDate} Days Before Due Date`}
                        name="NoDaysToNotifyBeforeDueDate"
                        type="number"
                        labelColor="dark"
                        required={true}
                        min="1"
                        max="99"
                        error={errors?.NoDaysToNotifyBeforeDueDate?.message}
                        disabled={canDisplayClassPostDuedate}
                        onChange={notifyChange}
                      />
                      <div className={classes.notify_error}>
                        {notifyChangeErrorMsg}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {!canDisplayClassPostDuedate ? (
                    <Input
                      label={<FormattedMessage id="VALIDDATE_TEXT" />}
                      name="DueDate"
                      placeholder={"Enter End Date"}
                      labelColor="dark"
                      type="date"
                      required
                      error={errors?.DueDate?.message}
                      disabled={canDisplayClassPostDuedate}
                      min={dateFormatyyyymmdd(new Date(date))}
                      onChange={dueDateChange}
                    />
                  ) : (
                    <div></div>
                  )}
                  <div className={classes.series_type_info}>
                    <Input
                      label={
                        <FormattedMessage id="DISTRIBUTE_PRG_ISSELFPACED_LBL" />
                      }
                      name="IsSelfPacedProgram"
                      type="checkbox"
                      labelColor="dark"
                      direction="row-reverse"
                      width="2"
                      height="2"
                      disabled={
                        canDisplayClassPostDuedate ||
                        // formData?.details?.Status ||
                        pathType === "copy" ||
                        formData?.details?.Status
                      }
                      //info="Learner can complete the series at his own pace. It allows learner to complete one Shotclass at a time and the next Shotclass will be pushed after completion of the former."
                    />
                    {/* <Tooltip
                      content={
                        <span>
                          <FormattedMessage id="DISTRIBUTE_PRG_ISSELFPACED_INFO_LBL" />
                        </span>
                      }
                      direction="bottom"
                    > */}
                    <span
                      title={intl.formatMessage({
                        id: "DISTRIBUTE_PRG_ISSELFPACED_INFO_LBL",
                      })}
                      className={classes.series_type}
                    >
                      <InfoIcon />
                    </span>
                    {/* </Tooltip> */}
                  </div>
                  <div className={classes.series_type_info}>
                    <Input
                      label={
                        <FormattedMessage id="DISTRIBUTE_PRG_ISSpreadProgram_LBL" />
                      }
                      name="IsSpreadProgram"
                      type="checkbox"
                      labelColor="dark"
                      direction="row-reverse"
                      width="2"
                      height="2"
                      disabled={
                        canDisplayClassPostDuedate ||
                        // formData?.details?.Status ||
                        pathType === "copy" ||
                        formData?.details?.Status
                      }
                      // info="Shotclasses are assigned at a uniform stretch based on the due date. It allows learner to get Shotclasses based on pending Shotclasses and due date."
                    />
                    {/* <Tooltip
                      content={
                        <span>
                          <FormattedMessage id="DISTRIBUTE_PRG_Stretched_INFO_LBL" />
                        </span>
                      }
                      direction="bottom"
                    >
                      <InfoIcon />
                    </Tooltip> */}
                    <span
                      title={intl.formatMessage({
                        id: "DISTRIBUTE_PRG_Stretched_INFO_LBL",
                      })}
                      className={classes.series_type}
                    >
                      <InfoIcon />
                    </span>
                  </div>
                  <div className={classes.series_type_info}>
                    <Input
                      label="No Duedate"
                      name="CanDisplayClassPostDuedate"
                      type="checkbox"
                      labelColor="dark"
                      direction="row-reverse"
                      width="2"
                      height="2"
                      disabled={
                        // formData?.details?.Status ||
                        pathType === "copy" || formData?.details?.Status
                      }
                      onChange={(e) => {
                        if (!e.target.checked)
                          setValue("IsSelfPacedProgram", true);
                        else setValue("IsSelfPacedProgram", false);
                      }}
                      // info="The distributed series will no longer have a due date if the selection is made."
                    />
                    {/* <Tooltip
                      content={
                        <span>
                          <FormattedMessage id="DISTRIBUTE_PRG_DONOTUSE_INFO_LBL" />
                        </span>
                      }
                      direction="left"
                    >
                      <InfoIcon />
                    </Tooltip> */}
                    <span
                      title={intl.formatMessage({
                        id: "DISTRIBUTE_PRG_DONOTUSE_INFO_LBL",
                      })}
                      className={classes.series_type}
                    >
                      <InfoIcon />
                    </span>
                  </div>
                </div>
              </div>
              <RoleMenuChek
                feature={[
                  {
                    roleMenu: "",
                    MSOMMenu: featureList?.CERTIFICATE,
                  },
                ]}
              >
                <div className={classes.certificate}>
                  <div
                    className={classes.certificate_title + " " + classes.title}
                  >
                    Add Certificate Details
                  </div>
                  <div className={classes.certificate_form}>
                    <div className={classes.certificate_icon}>
                      <Input
                        label={<FormattedMessage id="ADD_CERTIFICATE" />}
                        name="Certificate"
                        type="select"
                        labelColor="dark"
                        placeholder={intl.formatMessage({
                          id: `CETIFICATE_SELECT`,
                        })}
                        valueArr={certificateData}
                        loading={certificateLoader}
                        fieldName="Name"
                        fieldValue="CertificateID"
                        value={certificate}
                        onChange={(e) => {
                          setValue("Certificate", e.target.value);
                          certificateData?.forEach((cert) => {
                            if (
                              cert?.CertificateID?.toString() ===
                              e.target.value?.toString()
                            ) {
                              setSelectedCertificate(cert);
                              dispatch(setCertificateByProgramIdAction(cert));
                              return;
                            }
                          });
                        }}
                      />
                      {certificate && (
                        <div
                          className={classes.icon}
                          onClick={() => setIsViewModal(true)}
                        >
                          <ViewIcon fill={colors.theme} />
                        </div>
                      )}
                    </div>
                    <Input
                      label={<FormattedMessage id="Cer_Name" />}
                      name="Title"
                      labelColor="dark"
                      maxLength={40}
                      placeholder={intl.formatMessage({
                        id: `Cer_Name`,
                      })}
                    />
                  </div>
                </div>
              </RoleMenuChek>
              <div className={classes.seriesBtns}>
                {!isDirty && (
                  <div
                    className={classes.clearAll}
                    onClick={() =>
                      navigate(`${seriesManagement.path(tenantName)}`)
                    }
                  >
                    <FormattedMessage id="CANCEL_TEXT" />
                  </div>
                )}
                {isDirty && (
                  <div className={classes.clearAll} onClick={clearAll}>
                    <FormattedMessage id="CLEAR_ALL_TXT" />
                  </div>
                )}
                {/* <Button
                  label="Save As Draft"
                  small
                  dark
                  onClick={saveSeries}
                  disabled={!isValid}
                /> */}
                <Button
                  label="Save & Next"
                  type="submit"
                  small
                  dark
                  disabled={
                    !isValid ||
                    notifyChangeErrorMsg ||
                    !validClassName ||
                    !validTagSearch ||
                    exitTopicExist ||
                    !tagListValid
                  }
                />
              </div>
            </div>
          )}
        </form>
      </FormProvider>
      {/* <ViewCertificateModal
        isViewModal={isViewModal}
        setIsViewModal={setIsViewModal}
        title={title}
        selectedCertificate={selectedCertificate}
      /> */}
      <Modal
        isOpen={isViewModal}
        heading={<FormattedMessage id="VIEW_SHOTCLASS_HOME" />}
        toggle={() => setIsViewModal(0)}
        width="60"
        height="44"
        // loading={deleteCertificateModal}
      >
        <ViewContent
          shotclassData={{
            Mediatype: 7,
            VideoUrl: certificateByProgramId?.CertificateUrl,
            Name: certificateByProgramId?.Name,
          }}
        />
      </Modal>
      <SelectThumbnailPopUp
        isOpenModal={isSselectThumbnailModal}
        setIsOpenModal={setIsSselectThumbnailModal}
        okBtnClick={okBtnClick}
      />
    </div>
  );
};

export default injectIntl(SeriesDetail);
